// Shared helpers for the unified ReconWorkspace and its per-PSP configs.
// See docs/recon-workspace-design.md. These are presentation-only; no PSP-specific logic lives here.

export const fmtMoney = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch { return String(iso || '').slice(0, 10); } };
export const fmtDateTime = (iso) => { try { return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }); } catch { return String(iso || ''); } };
// "Last synced" label (Central time) shown under the Sync-now control; 'never' when there is no timestamp.
export const fmtLastSynced = (iso) => { if (!iso) return 'never'; try { return new Date(iso).toLocaleString('en-US', { timeZone: 'America/Chicago', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' CT'; } catch { return 'never'; } };

// Standard period filter: Year + Month, both defaulting to "all". Years run back to 2019 to cover
// the oldest backfilled payments. (Matches docs/ui-ux-guidelines.md.)
const CUR_Y = new Date().getFullYear();
export const YEAR_OPTIONS = [{ value: 'all', label: 'All years' }, ...Array.from({ length: CUR_Y - 2019 + 1 }, (_, i) => ({ value: String(CUR_Y - i), label: String(CUR_Y - i) }))];
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const MONTH_OPTIONS = [{ value: 'all', label: 'All months' }, ...MONTH_NAMES.map((m, i) => ({ value: String(i + 1), label: m }))];

// Pledge-order status → {label, color} for the small chip shown beside a linked pledge order. One mapping,
// reused by the Recurring report and the per-PSP subscription workspaces. Returns null for anything else.
export const pledgeStatusMeta = (s) => (s === 'pledge-completed'
  ? { label: 'Completed', color: 'success' }
  : s === 'pledge-pending' ? { label: 'Pending', color: 'warning' } : null);

// Stripe-style multi-account chip colors (ICCT / Kotilinga). PSPs without accounts never use these.
export const ACCOUNT_LABEL = { icct: 'ICCT', kotilinga: 'Kotilinga' };
export const accountColor = (a) => (a === 'kotilinga' ? 'secondary' : 'primary');

// Shared account-tab styling (browser-tab-style pills sitting on a baseline border). Used by the
// ReconWorkspace header and the AuthNet workspace shell so account selection looks identical everywhere.
export const ACCOUNT_TAB_SX = {
  minHeight: 44,
  '& .MuiTab-root': {
    minHeight: 40, fontWeight: 600, textTransform: 'none', mr: 0.75, mt: 0.5,
    border: '1px solid', borderColor: 'divider', borderBottom: 'none',
    borderRadius: '8px 8px 0 0', bgcolor: 'grey.100', color: 'text.secondary',
  },
  '& .Mui-selected': { bgcolor: 'primary.50', color: 'primary.main', borderColor: 'primary.light' },
  '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
};
